import React, { useState, useEffect, useRef } from 'react';
import { FacebookShareButton, EmailShareButton, PinterestShareButton, TwitterShareButton } from 'react-share';
import LinkCopierContainer from '../../global/LinkCopierContainer';
import { getFileName, segmentTrackEvent } from '../../../utils';
import { SITE_HOST, SOCIAL_SHARE_IMAGE_DEFAULT } from '../../../consts';
import "./social-share-buttons.scss"

const SocialShareButtons = ({
    parent,
    article,
    isMobile,
    togglePrint,
}) => {

    const [scrollY, setScrollY] = useState(0);
    const [top, setTop] = useState(0);
    const ref = useRef();

    useEffect(() => {
        const handleScroll = () => {
          setScrollY(window.scrollY);
          if (ref.current) {
              setTop(ref.current.offsetTop);
          }
        };

    
        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, [scrollY, top]);

    const { headline, hedUrl, category, social, tags, heroImage, seo } = article;
    const { facebookImageAlt, pinterestImageAlt } = social;
    // alt text not appearing in share buttons on FE
    const imageSrc = isMobile ? heroImage.imageSrcMobile : heroImage.imageSrcDesktop;
    const shareUrl = `${SITE_HOST}/${category}/${hedUrl}`;
    // const shareUrl = `https://purewow.com/${category}/${hedUrl}`;
    // for testing in local env ^
    const emailBody = `${headline} -- Sign up for PureWow ${SITE_HOST}/subscribe`;
    let renderedSocials;

    if (parent === 'sidebar' && !isMobile) {
        renderedSocials = 
        <div className={`social-sidebar ${(scrollY > (top - 200)) && (scrollY !== 0) ? 'sticky' : 'scroll'}`}>
            <PinterestShareButton
                className="social-share-unit pinterest"
                beforeOnClick={() => segmentTrackEvent('surround_article', {action: 'social', label: 'pin_side'})}
                url={shareUrl}
                alt={pinterestImageAlt || 'pinterest share image'}
                description={seo.metaDescription}
                media={social.pinterestImage || imageSrc || 'https://www.purewow.com/static-gmg/purewow/logos/purewow-mark-salmon.jpg'}>
            </PinterestShareButton>
            <FacebookShareButton
                className="social-share-unit facebook"
                beforeOnClick={() => segmentTrackEvent('surround_article', {action: 'social', label: 'facebook_side'})}
                url={shareUrl}
                alt={facebookImageAlt || 'facebook share image'}>
            </FacebookShareButton>
            <TwitterShareButton
                className="social-share-unit twitter"
                beforeOnClick={() => segmentTrackEvent('surround_article', {action: 'social', label: 'twitter_side'})}
                url={shareUrl}
                title={seo.titleTag}
                alt={social.facebookImageAlt || 'twitter share image'}>
            </TwitterShareButton>
            <LinkCopierContainer module="sticky" />
            <EmailShareButton
                subject={headline}
                url={shareUrl}
                separator={' -- '}
                body={emailBody}
                className="social-share-unit email"
                beforeOnClick={() => segmentTrackEvent('surround_article', {action: 'social', label: 'email_side'})}>
            </EmailShareButton>
        </div>
    }

    if (parent === 'eop') {
        renderedSocials = 
        <div className="social-sidebar eop">
            <PinterestShareButton
                className="social-share-unit pinterest"
                beforeOnClick={() => segmentTrackEvent('surround_article', {action: 'social', label: 'pin_bottom'})}
                url={shareUrl}
                alt={pinterestImageAlt || 'pinterest share image'}
                description={`${seo.metaDescription} ${tags}`}
                media={social.pinterestImage || imageSrc || SOCIAL_SHARE_IMAGE_DEFAULT}>
            </PinterestShareButton>
            <FacebookShareButton
                className="social-share-unit facebook"
                beforeOnClick={() => segmentTrackEvent('surround_article', {action: 'social', label: 'facebook_bottom'})}
                url={shareUrl}
                alt={facebookImageAlt || 'facebook share image'}>
            </FacebookShareButton>
             <TwitterShareButton
                className="social-share-unit twitter"
                beforeOnClick={() => segmentTrackEvent('surround_article', {action: 'social', label: 'twitter_side'})}
                url={shareUrl}
                title={seo.titleTag}
                alt={social.facebookImageAlt || 'twitter share image'}>
            </TwitterShareButton>
            <LinkCopierContainer module="eop" />
            <EmailShareButton
                subject={headline}
                url={shareUrl}
                separator={' -- '}
                body={emailBody}
                className="social-share-unit email"
                beforeOnClick={() => segmentTrackEvent('surround_article', {action: 'email', label: 'bottom'})}>
            </EmailShareButton>
            {category === 'recipes'
                && <span onClick={() => {togglePrint(); segmentTrackEvent('surround_article', {action: 'print', label: 'bottom'})}} className="social-share-unit print"></span>
            }
        </div>
    }

  return (
        <div className="social-share-buttons" ref={ref}>
            {renderedSocials}
        </div>
  );
};

export default SocialShareButtons;
